<form
  class="account-form"
  [formGroup]="formGroup()"
>
  @for (field of formFields(); track $index) {
    @if (field.stepVisible.includes(currentStep())) {
      @if (field.fieldName === 'phone') {
        <mat-form-field
          appearance="outline"
          [class.none-pointer-events]="isDisabled(field.disabled)"
        >
          <mat-label>
            {{ field.label }}
          </mat-label>
          <input
            appPhoneMask
            matInput
            [type]="field.type"
            [formControlName]="field.fieldName"
          >
        </mat-form-field>
      } @else {
        <mat-form-field
          appearance="outline"
          [class.none-pointer-events]="isDisabled(field.disabled)"
        >
          <mat-label>
            {{ field.label }}
          </mat-label>
          <input
            matInput
            [type]="field.type"
            [formControlName]="field.fieldName"
          >
        </mat-form-field>
      }
    }
  }
</form>
